export default __webpack_public_path__ + "static/11_15-3fb62b554942d307b6ec849b31d8940e.png";